import React from "react";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "./orderSummary.styles";
import Formatter from '../../../classes/Formatter/Formatter';

const OrderSummary = (props) => {
  const classes = useStyles();

  return (
    <Box className={classes.summaryCard}>
      <Typography className={classes.summaryHeader}>ORDER SUMMARY</Typography>

      <Box className={classes.itemsContainer}>
        <Box className={classes.summaryRow}>
          <Typography className={classes.itemLabel}>Unit Price</Typography>
          <Typography className={classes.itemValue}>
            USD {parseFloat(props.price).toFixed(2)}
          </Typography>
        </Box>

        <Box className={classes.summaryRow}>
          <Typography className={classes.itemLabel}>Quantity</Typography>
          <Typography className={classes.itemValue}>
            {props.counter.toString().padStart(2, "0")}
            {/* USD {parseFloat(props.subtotal).toFixed(2)} */}
          </Typography>
        </Box>

        <Box className={classes.summaryRow}>
          <Typography className={classes.itemLabel}>
            Carbon Registry Fee
          </Typography>
          <Typography className={classes.itemValue}>
            {/* USD {parseFloat(props.fee).toFixed(2)} */}
             USD {Formatter.round(props.fee)}
          </Typography>
        </Box>
      </Box>

      <Box className={classes.totalSection}>
        <Box className={classes.totalLabelRow}>
          <Typography className={classes.totalLabel}>TOTAL PAYABLE</Typography>
          <Box className={classes.liveRateBadge}>
            <span className={classes.liveRateDot} />
            <Typography className={classes.liveRateText}>LIVERATE</Typography>
          </Box>
        </Box>

        <Typography className={classes.totalAmount}>
          USD {parseFloat(props.total).toFixed(2)}
        </Typography>
      </Box>
    </Box>
  );
};

export default OrderSummary;
